import * as Types from '../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ConfirmShopifyInstallationMutationVariables = Types.Exact<{
  input: Types.ConfirmShopifyInstallationInput;
}>;


export type ConfirmShopifyInstallationMutation = { __typename?: 'RootMutationType', confirmShopifyInstallation?: { __typename?: 'ConfirmShopifyInstallationResult', success?: boolean | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };


export const ConfirmShopifyInstallationDocument = gql`
    mutation confirmShopifyInstallation($input: ConfirmShopifyInstallationInput!) {
  confirmShopifyInstallation(input: $input) {
    success
    userErrors {
      field
      message
    }
  }
}
    `;
export type ConfirmShopifyInstallationMutationFn = Apollo.MutationFunction<ConfirmShopifyInstallationMutation, ConfirmShopifyInstallationMutationVariables>;

/**
 * __useConfirmShopifyInstallationMutation__
 *
 * To run a mutation, you first call `useConfirmShopifyInstallationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmShopifyInstallationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmShopifyInstallationMutation, { data, loading, error }] = useConfirmShopifyInstallationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmShopifyInstallationMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmShopifyInstallationMutation, ConfirmShopifyInstallationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmShopifyInstallationMutation, ConfirmShopifyInstallationMutationVariables>(ConfirmShopifyInstallationDocument, options);
      }
export type ConfirmShopifyInstallationMutationHookResult = ReturnType<typeof useConfirmShopifyInstallationMutation>;
export type ConfirmShopifyInstallationMutationResult = Apollo.MutationResult<ConfirmShopifyInstallationMutation>;
export type ConfirmShopifyInstallationMutationOptions = Apollo.BaseMutationOptions<ConfirmShopifyInstallationMutation, ConfirmShopifyInstallationMutationVariables>;